'use client';

import { useUserContext } from '@/context/user';
import clsx from 'clsx';
import BenefitsTable from './benefitsTable';
import EarnPoints from './earnPoints';
import FrequentlyQuestion from './frequentlyQuestion';
import RedeemPoints from './redeemPoints';
import TopBanner from './topBanner';
import WorkSteps from './workSteps';

const RewardsProgramPage = () => {
  const [{ isSignedIn }] = useUserContext();

  return (
    <>
      <TopBanner />
      <BenefitsTable className={clsx(isSignedIn ? 'mt-[32px] lg_mt-[64px]' : 'mt-[60px] lg_mt-[150px]')} />
      <WorkSteps className='mt-[60px] lg_mt-[150px]' />
      <EarnPoints className='mt-[60px] lg_mt-[150px]' />
      <RedeemPoints className='mt-[60px] lg_mt-[150px]' />
      <FrequentlyQuestion className=' mt-[60px] lg_mt-[150px]' />
    </>
  );
};

export default RewardsProgramPage;
